module.exports = __webpack_public_path__ + "static/media/shenghuozhaoliao@2x.c29fda14.png";